const getTimeRemaining = (startTime, endTime) => {
    const total = endTime - startTime;
    const seconds = Math.floor(total % 60);
    const minutes = Math.floor((total / 60) % 60);
    const hours = Math.floor((total / (60 * 60)) % 24);
    const days = Math.floor(total / (60 * 60 * 24));

    return {
        total,
        days,
        hours,
        minutes,
        seconds,
    };
};

const getStopWatchTime = timeInSeconds => {
    const seconds = Math.floor(timeInSeconds % 60);
    const minutes = Math.floor((timeInSeconds / 60) % 60);
    const hours = Math.floor((timeInSeconds / (60 * 60)) % 24);
    const days = Math.floor(timeInSeconds / (60 * 60 * 24));

    return {
        timeInSeconds,
        days,
        hours,
        minutes,
        seconds,
    };
}

const verifyArgs = (elem, startTime, endTime) => {
    if (!elem)
        return false;
        // throw new Error(`Invalid HTML object identifier! (${id} not found)`);
    if (!new Date(startTime).getTime() > 0)
        return false;
        // throw new Error(`Invalid startTime timestamp! (${startTime})`);
    if (!new Date(endTime).getTime() > 0)
        return false;
        // throw new Error(`Invalid endTime timestamp! ${endTime}`);
    if (endTime < startTime)
        return false;
        // throw new Error(`startTime is larger than endTime!`);
    return true;
}

window.countdownTimer = function (id, nowTime, endTime) {
    const clock = document.getElementById(id);
    clock.classList.remove('countdownTimer_start')
    // verifyArgs(clock, nowTime, endTime)

    function updateClock() {
        const time = getTimeRemaining(nowTime, endTime);
        if (time.total >= 0) {
            clock.innerHTML = `- ${time.days > 0 ? `${time.days}d` : ""} ${time.hours > 0 ? `${time.hours}h` : ''}
                ${time.minutes}m ${time.seconds}s`;
        }

        if (time.total <= 0) {
            clearInterval(cd_interval);
        }

        nowTime += 1;
    }

    const cd_interval = setInterval(updateClock, 1000);
}

window.stopwatch = function (id, activeClassName, startTime, nowTime) {
    /*
    * Stopwatch JS module
    *
    * id [string]  Name of HTML element that should show the time
    * activeClassName [string] Name of class that indicates that the timer is active
    * startTime [int timestamp] timestamp of the place in time where the stopwatch starts
    * nowTime [int timestamp] timestamp of server time at the time of render
    *   * to prevent the user from messing with the time on the client side
    * */
    let diff = nowTime - startTime;
    if ((diff < 0) && (diff >= -7200)) {
        startTime -= 7200;
    }
    const clock = document.getElementById(id);
    if (verifyArgs(clock, startTime, nowTime)) {
        const updateClock = (initialization = false) => {
            if (clock.classList.contains(activeClassName) || initialization) {
                if (clock.classList.contains('init')) {
                    startTime = parseInt(clock.getAttribute('data-start'));
                    nowTime = parseInt(clock.getAttribute('data-now'));
                    clock.classList.remove('init');

                    let diff = nowTime - startTime;
                    if ((diff < 0) && (diff >= -7200)) {
                        startTime -= 7200;
                    }
                }

                const time = getStopWatchTime(nowTime - startTime);
                clock.innerHTML = `${time.days > 0 ? `${time.days}d` : ""} ${time.hours > 0 ? `${time.hours}h` : ''}
                ${time.minutes}m ${time.seconds}s`;
            }

            nowTime += 1;
        }
        updateClock(true)
        const cup_interval = setInterval(() => updateClock(), 1000);
    }
}
